export default {
  law: {
    title: '特定商取引法に基づく表記',
    serviceName: 'Service Name',
    companyName: 'Seller',
    representative: 'Representative',
    address: 'Address',
    contact: 'Contact',
    paymentTerms: 'Payment Method and Timing',
    deliverySchedule: 'Delivery Schedule',
    sellingPrice: 'Selling Price',
    shippingFee: 'Shipping Fee',
    additionalFee: 'Additional Fees',
    salesRestrictions: 'Sales Restrictions',
    returnsAndCancellations: 'Returns and Cancellations',
    otherConditions: 'Other Conditions'
  }
};
